import React from "react";

import { Typography } from "clearsense-ui/components";

const Section = ({ section, info }) => (
  <div className="w-full p-4 space-y-4 bg-white dark:bg-gray-800 border-2">
    <Typography style="h4" type="bold">
      {section}
    </Typography>
    {info.map(({ field, value }, idx) => (
      <div className="grid w-full grid-cols-2 gap-2" key={idx}>
        <Typography style="h4">{field}</Typography>
        <Typography style="h4" className="text-primary-shade">
          {value}
        </Typography>
      </div>
    ))}
  </div>
);

export default Section;
